import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { workflowDetailSearchSchema } from '../../../features/workflows/search'
import { WorkflowDetailPage } from '../../../features/workflows/workflow-detail-page'

export const Route = createFileRoute('/_app/workflows/$workflowId')({
  validateSearch: workflowDetailSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'workflows.read'),
  component: WorkflowDetailPage,
})
